import Markdown from "react-markdown";
import usePartyStore from "../../../stores/party.js";
import { gameIndex } from "@tumbodash/clientGameEngine";

function Instructions() {
	const party = usePartyStore.getState().party!;
	const round = party.rounds[party.activeRoundId];
	const detail = Object.values(gameIndex).find(g => g.slug === round.gameSlug);

	const modifiers = (detail as Record<string, unknown>)?.modifiers as Array<{ id: string; label: string; instructions?: string }> | undefined;
	const activeModifiers = modifiers?.filter(m => round.modifierIds?.includes(m.id)) ?? [];

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
			<div style={{
				color: "var(--text-secondary)",
				fontSize: "0.92rem",
				lineHeight: 1.65,
			}}>
				<Markdown>{detail.instructions}</Markdown>
			</div>

			{activeModifiers.map(modifier => modifier.instructions && (
				<div key={modifier.id} style={{
					borderTop: "1px solid var(--border)",
					paddingTop: "var(--space-4)",
				}}>
					<div style={{
						fontSize: "0.72rem",
						fontWeight: 700,
						letterSpacing: "0.08em",
						textTransform: "uppercase",
						color: "var(--text-muted)",
						marginBottom: "var(--space-2)",
					}}>
						Modifier — {modifier.label}
					</div>
					<div style={{ color: "var(--text-secondary)", fontSize: "0.9rem", lineHeight: 1.6 }}>
						{modifier.instructions}
					</div>
				</div>
			))}
		</div>
	);
}

export default Instructions;
